module["exports"] = [
  "Canada"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/fr_CA/address/default_country.js
 ** module id = 705
 ** module chunks = 0
 **/